'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtDataDiffMarker', [
	function () {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				diffMarker: '='
			},
			link: function (scope, element, attrs) {
				scope.marker = 'loader';
				let getMarker = function () {
					if (scope.diffMarker) {
						scope.marker = scope.diffMarker;
						return;
					}
				};

				attrs.$observe('diffMarker', function (newVal) {
					if (newVal) {
						getMarker();
					}
				});

				scope.$watch(
					'diffMarker',
					function (newVal) {
						if (newVal) {
							getMarker();
						}
					},
					true
				);
			},
			templateUrl: 'components/location/overview/pmtDataDiffMarker.html'
		};
	}
]);
